<div class="content">
    <div>
        <div class="title"><img [title]="title" [alt]="title" src="assets/images/logo.svg" height="130"></div>
        <div class="header">You do not have permission to access this {{ type }}.</div>
        <div class="detail">
            To request access, please use the following link:
            <div class="support"><a (click)="goToDialog()"  target="_blank" rel="noopener noreferrer">{{ title }}</a></div>
        </div>
    </div>
</div>
